<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
             <router-link
      :to="
        '/BranchSalesReportAllDetailsPrint?id=' +
          select_branch.id +
          '&from=' +
          date_from +
          '&to=' +
          date_to +
          '&name=' +
          select_branch.name
      "
      target="_blank"
    >
      <v-icon>print</v-icon>
    </router-link>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm12 md12>
          <p style="font-size:18px">
            <b
              ><u>
                تقرير مفصل فرع {{ select_branch.name }} بتاريخ من
                {{ date_from }} الي تاريخ {{ date_to }}</u
              >
            </b>
          </p>
        </v-flex>
        <!-- <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="select_item"
                    :items="items"
                    item-text="name"
                    item-value="id"
                    label="أختر الصنف"
                    persistent-hint
                    return-object
                    single-line
                   
                ></v-select>
                  </v-flex>  -->
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_branch"
            :items="branches"
            item-text="name"
            item-value="id"
            label=" أختر الفرع "
            persistent-hint
            return-object
            single-line
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_from"
            v-model="modal_from"
            :return-value.sync="date_from"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_from"
                label="تاريخ من"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_from" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_from = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.dialog_from.save(date_from)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_to"
            v-model="modal_to"
            :return-value.sync="date_to"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_to"
                label="تاريخ الي"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_to" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_to = false"
                >Cancel</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dialog_to.save(date_to)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>

        <v-flex xs12 sm6 md2>
          <v-btn @click="BranchSalesReportAllDetail">تأكيد</v-btn>
        </v-flex>
        <br />
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm3 md3>
          <p style="font-size:20px;font-weight:bold">
            مجموع المبيعات : {{ fatworas_sum }}
          </p></v-flex
        >
        <v-flex xs12 sm3 md3>
          <p style="font-size:20px;font-weight:bold">
            مجموع المرتجعات : {{ fatworas2_sum }}
          </p></v-flex
        >
        <v-flex xs12 sm3 md3>
          <p style="font-size:20px;font-weight:bold">
            مجموع المشنتريات : {{ fatworas3_sum }}
          </p></v-flex
        >
        <v-flex xs12 sm3 md3>
          <p style="font-size:20px;font-weight:bold">
            مجموع مرتجعات المشتريات : {{ fatworas4_sum }}
          </p></v-flex
        >
        <v-flex xs12 sm3 md3>
          <p style="font-size:20px;font-weight:bold">
            مجموع المصروفات : {{ fatworas5_sum }}
          </p></v-flex
        >
        <v-flex xs12 sm3 md3>
          <p style="font-size:20px;font-weight:bold">
            مجموع السدادات : {{ fatworas6_sum }}
          </p></v-flex
        >
        <v-flex xs12 sm3 md3>
          <p style="font-size:20px;font-weight:bold">
            مجموع الخصومات : {{ fatworas7_sum }}
          </p></v-flex
        >
      </v-layout>
      <v-layout v-if="fatworas.length > 0">
        <v-flex
          xs12
          sm12
          md12
          style="    text-align: center;font-size: 30px;font-weight: bold;color: orangered;"
        >
          المبيعات</v-flex
        >
      </v-layout>

      <v-data-table
        :headers="headers1"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.client ? props.item.client.name : "" }}</td>
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.discount }}</td>
          <td class="text-xs-right">{{ props.item.price_before }}</td>
          <td class="text-xs-right">{{ props.item.price_after }}</td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
          <td class="text-xs-right">{{ props.item.taslim_date }}</td>
          <td class="text-xs-right">
            {{ props.item.store ? props.item.store.name : "" }}
          </td>
          <td class="text-xs-right">{{ props.item.sdad_status }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مبيعات</div>

      <v-layout>
        <v-flex
          xs12
          sm12
          md12
          style=" text-align: center;font-size: 30px;font-weight: bold;color: orangered;"
          v-if="fatworas2.length > 0"
        >
          مرتجع المبيعات
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers2"
        :items="fatworas2"
        class="elevation-1"
        v-if="fatworas2.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.client ? props.item.client.name : "" }}</td>
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.reback_discount }}</td>
          <td class="text-xs-right">{{ props.item.price_before }}</td>
          <td class="text-xs-right">{{ props.item.price_after }}</td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مرتجع مبيعات</div>
      <v-layout>
        <v-flex
          xs12
          sm12
          md12
          style="    text-align: center;font-size: 30px;font-weight: bold;color: orangered;"
          v-if="fatworas3.length > 0"
        >
          المشتريات
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers3"
        :items="fatworas3"
        class="elevation-1"
        v-if="fatworas3.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.importer ? props.item.importer.name : "" }}</td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.paper_code }}</td>
          <td class="text-xs-right">{{ props.item.price }}</td>
          <td class="text-xs-right">{{ props.item.fatwora_dicount }}</td>
          <td class="text-xs-right">{{ props.item.final_price }}</td>
          <td class="text-xs-right">
            {{ props.item.store ? props.item.store.name : "" }}
          </td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مشتريات</div>

      <v-layout>
        <v-flex
          xs12
          sm12
          md12
          style="    text-align: center;font-size: 30px;font-weight: bold;color: orangered;"
          v-if="fatworas4.length > 0"
        >
          مرتجع المشتريات
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers4"
        :items="fatworas4"
        class="elevation-1"
        v-if="fatworas4.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.importer ? props.item.importer.name : "" }}</td>
          <td class="text-xs-right">{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.price }}</td>
          <td class="text-xs-right">{{ props.item.fatwora_dicount_back }}</td>
          <td class="text-xs-right">{{ props.item.final_price }}</td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مرتجع مشتريات</div>

      <v-layout>
        <v-flex
          xs12
          sm12
          md12
          style="    text-align: center;font-size: 30px;font-weight: bold;color: orangered;"
          v-if="fatworas5.length > 0"
        >
          المصروفات
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers5"
        :items="fatworas5"
        class="elevation-1"
        v-if="fatworas5.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.money_q }}</td>
          <td class="text-xs-right">
            {{ props.item.money ? props.item.money.name : "" }}
          </td>
          <td class="text-xs-right">{{ props.item.emp_responsible_name }}</td>
          <td class="text-xs-right">{{ props.item.emp_name_to }}</td>
          <td class="text-xs-right">{{ props.item.notes }}</td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مصروفات</div>

      <v-layout>
        <v-flex
          xs12
          sm12
          md12
          style="    text-align: center;font-size: 30px;font-weight: bold;color: orangered;"
          v-if="fatworas6.length > 0"
        >
          سداد العملاء</v-flex
        >
      </v-layout>
      <v-data-table
        :headers="headers6"
        :items="fatworas6"
        class="elevation-1"
        v-if="fatworas6.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.client ? props.item.client.name : "" }}</td>
          <td class="text-xs-right">{{ props.item.money_q }}</td>
          <td class="text-xs-right">{{ props.item.note }}</td>
          <td class="text-xs-right">
            {{ props.item.mandob_tahsil ? props.item.mandob_tahsil.name : "" }}
          </td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير سدادات</div>

      <v-layout>
        <v-flex
          xs12
          sm12
          md12
          style="    text-align: center;font-size: 30px;font-weight: bold;color: orangered;"
          v-if="fatworas7.length > 0"
        >
          خصومات العملاء</v-flex
        >
      </v-layout>
      <v-data-table
        :headers="headers7"
        :items="fatworas7"
        class="elevation-1"
        v-if="fatworas7.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.client ? props.item.client.name : "" }}</td>
          <td class="text-xs-right">{{ props.item.money }}</td>
          <td class="text-xs-right">{{ props.item.note }}</td>
          <td class="text-xs-right">
            {{ props.item.user ? props.item.user.name : "" }}
          </td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير خصومات</div>
    </v-container>
  </div>
</template>

<script>
import {
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  branches,
  khazina,
  BranchSalesReportAllDetail
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [11400, 11800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,
    detail_dialog: false,
    add_dialog: false,
    edit_dialog: false,
    headers1: [
      {
        text: " اسم العميل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " كود العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " الخصم ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر قبل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر بعد ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التاريخ ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "تاريخ التسليم ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "اسم المخزن ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "حالة السداد",
        value: "address",
        sortable: false,
        align: "right"
      },
    ],

    headers2: [
      {
        text: " اسم العميل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "كود",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "الخصم المرتجع ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "سعر قبل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "سعر بعد ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التاريخ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers22: [
      {
        text: " كود",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " الكود اليدوي",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "الخصم المسترجع",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "سعر قبل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "سعر بعد",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التفاصيل",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers222: [
      {
        text: "الصنف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "العدد قبل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "العدد المرتجع",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "العدد المتبقي ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر الكلي",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers3: [
      {
        text: " اسم المورد",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " كود ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " الكود الورقي ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الخصم",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر بعد",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "المخزن",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التاريخ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers33: [
      {
        text: " كود",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الكود الورقي",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "السعر ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الخصم",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر النهائي ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التفاصيل",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers333: [
      {
        text: " اسم الصنف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "العدد",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "السعر",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر الكلي ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers4: [
      {
        text: " اسم المورد",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " كود ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر قبل ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الخصم المسترجع ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " السعر بعد",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " التاريخ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],

    headers5: [
      {
        text: " كود ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "المبلغ",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "نوع المصروف ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الموظف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "المستلم",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الملاحظات",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التاريخ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],

    headers6: [
      {
        text: " اسم العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "المبلغ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "ملحوظة",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " موظف التحصيل ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " التاريخ ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],

    headers7: [
      {
        text: " اسم العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "المبلغ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "ملحوظة",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "اسم المستخدم ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " التاريخ ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    active: "",
    select_item: { id: "" },
    select_branch: { id: "" },
    search: "",
    comment: "",
    loading: true,

    khazina_fatworas: [],
    items: [],
    fatworas: [],
    fatworas2: [],
    fatworas3: [],
    fatworas4: [],
    fatworas5: [],
    fatworas6: [],
    fatworas7: [],
    branches: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    item_detail1: {},
    item_detail12: {},
    item_detail2: {},
    item_detail22: {},
    item_detail3: {},
    item_detail32: {},
    item_detail4: {},
    item_detail42: {},
    item_detail5: {},
    item_detail52: {},
    item_detail6: {},
    item_detail62: {},
    detail_dialog1: false,
    detail_dialog12: false,
    detail_dialog2: false,
    detail_dialog22: false,
    detail_dialog3: false,
    detail_dialog32: false,
    detail_dialog4: false,
    detail_dialog42: false,
    detail_dialog5: false,
    detail_dialog52: false,
    detail_dialog6: false,
    detail_dialog62: false,
    all_of_total: 0,
    count_of_count: 0,
    all_of_total2: 0,
    count_of_count2: 0,
    all_of_total3: 0,
    count_of_count3: 0,
    all_of_total4: 0,
    count_of_count4: 0,
    all_of_total5: 0,
    count_of_count5: 0,
    all_of_total6: 0,
    count_of_count6: 0,
    madionia_sabqa_of_madionia: "",
    madionia_sabqa: "",
    fatworas_sum: "",
    fatworas2_sum: "",
    fatworas3_sum: "",
    fatworas4_sum: "",
    fatworas5_sum: "",
    fatworas6_sum: "",
    fatworas7_sum: ""
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    omola_percentage() {
      return function(total, omola) {
        return (parseFloat(total) * parseFloat(omola)) / 100;
      };
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      branches().then(response => {
        this.branches = response.data;
        this.loading = false;
      });
    },
    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_item = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_item.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_item.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_item.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina(this.select_branch.id).then(response => {
        this.theKhazna = response.data;
      });
    },
    detailItem1(order) {
      this.item_detail1 = order;
    },
    detailItem12(order) {
      this.item_detail12 = order;
    },
    detailItem2(order) {
      this.item_detail2 = order;
    },
    detailItem22(order) {
      this.item_detail22 = order;
    },
    detailItem3(order) {
      this.item_detail3 = order;
    },
    detailItem32(order) {
      this.item_detail32 = order;
    },
    detailItem4(order) {
      this.item_detail4 = order;
    },
    detailItem42(order) {
      this.item_detail42 = order;
    },
    detailItem5(order) {
      this.item_detail5 = order;
    },
    detailItem52(order) {
      this.item_detail52 = order;
    },
    detailItem6(order) {
      this.item_detail6 = order;
    },
    detailItem62(order) {
      this.item_detail62 = order;
    },
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    BranchSalesReportAllDetail() {
      var frmData = new FormData();
      frmData.append("branch_id", this.select_branch.id);
      frmData.append("date_from", this.date_from);
      frmData.append("date_to", this.date_to);
      BranchSalesReportAllDetail(frmData).then(response => {
        response.data.fatworas.length > 0
          ? (this.fatworas = response.data.fatworas)
          : (this.fatworas = []);
        response.data.fatworas2.length > 0
          ? (this.fatworas2 = response.data.fatworas2)
          : (this.fatworas2 = []);
        response.data.fatworas3.length > 0
          ? (this.fatworas3 = response.data.fatworas3)
          : (this.fatworas3 = []);
        response.data.fatworas4.length > 0
          ? (this.fatworas4 = response.data.fatworas4)
          : (this.fatworas4 = []);
        response.data.fatworas5.length > 0
          ? (this.fatworas5 = response.data.fatworas5)
          : (this.fatworas5 = []);
        response.data.fatworas6.length > 0
          ? (this.fatworas6 = response.data.fatworas6)
          : (this.fatworas6 = []);
        response.data.fatworas7.length > 0
          ? (this.fatworas7 = response.data.fatworas7)
          : (this.fatworas7 = []);
        this.fatworas_sum = response.data.fatworas_sum;
        this.fatworas2_sum = response.data.fatworas2_sum;
        this.fatworas3_sum = response.data.fatworas3_sum;
        this.fatworas4_sum = response.data.fatworas4_sum;
        this.fatworas5_sum = response.data.fatworas5_sum;
        this.fatworas6_sum = response.data.fatworas6_sum;
        this.fatworas7_sum = response.data.fatworas7_sum;
      });
    }
  }
};
</script>

<style scoped>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.v-icon.ml-4.v-icon--link.material-icons.theme--dark {
  font-size: 25px !important;
  z-index: 99999999;
}
</style>
